// react
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";

import router from "./router/router";

// get the store
import createStore from "../store";

import { queryClient } from "../api/queryClient";

import SentryErrorWrapper from "../app-config/SentryErrorWrapper";

// render the application using ReactDOM.render
const main = document.getElementById("react-app");
const root = createRoot(main);

if (main) {
	root.render(
		<Provider store={createStore()}>
			<React.StrictMode>
				<QueryClientProvider client={queryClient}>
					<SentryErrorWrapper>
						<RouterProvider router={router} />
						<ReactQueryDevtools initialIsOpen={false} buttonPosition="top-left" />
					</SentryErrorWrapper>
				</QueryClientProvider>
			</React.StrictMode>
		</Provider>
	);
}
